
export const calculateTeamGoals = (matches: any[], isHome?: boolean) => {
  let totalGoals = 0;
  const teamStats = new Map<string, { total: number; games: number }>();

  matches.forEach(match => {
    let matchGoals = 0;
    
    if (isHome === true) {
      matchGoals = parseInt(match.FTHG) || 0;
      totalGoals += matchGoals;
      const team = match.HomeTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchGoals;
      stats.games += 1;
    } else if (isHome === false) {
      matchGoals = parseInt(match.FTAG) || 0;
      totalGoals += matchGoals;
      const team = match.AwayTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchGoals;
      stats.games += 1;
    } else {
      const homeGoals = parseInt(match.FTHG) || 0;
      const awayGoals = parseInt(match.FTAG) || 0;
      matchGoals = homeGoals + awayGoals;
      totalGoals += matchGoals;
      
      const homeTeam = match.HomeTeam;
      if (!teamStats.has(homeTeam)) {
        teamStats.set(homeTeam, { total: 0, games: 0 });
      }
      const homeStats = teamStats.get(homeTeam)!;
      homeStats.total += homeGoals;
      homeStats.games += 1;

      const awayTeam = match.AwayTeam;
      if (!teamStats.has(awayTeam)) {
        teamStats.set(awayTeam, { total: 0, games: 0 });
      }
      const awayStats = teamStats.get(awayTeam)!;
      awayStats.total += awayGoals;
      awayStats.games += 1;
    }
  });

  let mostGoals = { team: '', value: 0 };
  let leastGoals = { team: '', value: Infinity };

  teamStats.forEach((stats, team) => {
    const average = stats.total / stats.games;
    if (average > mostGoals.value) {
      mostGoals = { team, value: average };
    }
    if (average < leastGoals.value) {
      leastGoals = { team, value: average };
    }
  });

  const totalMatches = matches.length;
  const average = (totalGoals / totalMatches).toFixed(2);

  return {
    totalGoals,
    average,
    mostGoals,
    leastGoals
  };
};
